export default {
	loading: 'loading',
	pending: 'pending',
	success: 'success',
	fail: 'fail',
};



// WEBPACK FOOTER //
// ./src/constants/status.js